import { clampColumnWidth, measureHeaderMinWidth } from "./columnWidthConstraints";

const BODY_SAMPLE_ROWS = 100;
const BODY_PADDING_X = 32;

/**
 * Measure optimal column width from rendered DOM (list/detail tables with rich cells).
 *
 * @param {Object} params
 * @param {HTMLElement} params.tableElement - The table root
 * @param {string} params.columnKey - data-column-key on th/td
 * @param {string} [params.headerLabel] - Display label for header min
 * @param {boolean} [params.hasSort]
 * @param {boolean} [params.hasFilter]
 * @returns {number}
 */
export const measureColumnFitFromDom = ({
  tableElement,
  columnKey,
  headerLabel = "",
  hasSort = false,
  hasFilter = false,
}) => {
  if (!tableElement || !columnKey) {
    return clampColumnWidth(measureHeaderMinWidth({ label: headerLabel, hasSort, hasFilter }));
  }

  const headerMin = measureHeaderMinWidth({ label: headerLabel, hasSort, hasFilter });

  const th = tableElement.querySelector(`th[data-column-key="${columnKey}"]`);
  const cellIndex = th?.cellIndex;
  let maxContent = 0;

  if (cellIndex != null && cellIndex >= 0) {
    const rows = tableElement.querySelectorAll("tbody tr");
    const limit = Math.min(rows.length, BODY_SAMPLE_ROWS);
    for (let i = 0; i < limit; i += 1) {
      const cell = rows[i]?.cells?.[cellIndex];
      if (!cell) continue;
      const contentWidth = cell.scrollWidth;
      if (contentWidth > maxContent) maxContent = contentWidth;
    }
  }

  const bodyRequired = maxContent > 0 ? maxContent + BODY_PADDING_X : headerMin;
  return clampColumnWidth(Math.max(headerMin, bodyRequired), headerMin);
};
